import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import axios from 'axios'
import Vue from 'vue'

Vue.use(axios)

const state = {
  token: localStorage.getItem('user-token') || '',
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getToken: state => state.token
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/login/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': user.language
        },
        data: user
      }
      axios(config)
        .then(function (res) {
          localStorage.setItem('user-token', res.data.token)
          commit(AUTH_SUCCESS, res.data.token)
          dispatch(USER_REQUEST).finally(() => resolve(res))
        })
        .catch(function (err) {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },

  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/logout/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + localStorage.getItem('user-token')
        }
      }
      axios(config)
        .then(function () {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          resolve()
        })
        .catch(function (err) {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
